/* eslint-disable jsx-a11y/anchor-is-valid */

import {
  useState,
} from 'react';

import { useFormik } from 'formik';
import _ from "lodash";
import { Modal } from "react-bootstrap";
import SVG from 'react-inlinesvg';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import {
  toAbsoluteUrl
} from '../../../_metronic/helpers';

import {
  formatLongDateTime,
  getLabel,
} from '../../services/dates';

import {
  fetchCouponCode,
} from '../../services/coupons';

const ListBranchCoupons = ({isOpen, onClosed, onSelect, selectedCoupon, branchId, date = '', sellingType = 'single', sellingModality = 'reservation'}) => {
  const { coupons } = useSelector((state : any) => ({
    coupons: state.coupons,
  }), shallowEqual);

  const dispatch = useDispatch();

  const [showRules, setShowRules] = useState<any>('');
  const [messageCouponCode, setMessageCouponCode] = useState<any>('');

  const parseWeekDays = (weekdays) => {
    let data = weekdays.map(weekday => getLabel(weekday));

    return data.slice(0, -1).join(', ')+' e '+data.slice(-1);
  }

  const parseValue = (value, type) => {
    let message = 'R$ ' + value;

    if (type == 'percentage') {
      message = value + '% na compra';
    }

    return message;
  }

  const confirm = (value) => {
    onSelect(value);
    setShowRules('');
    setMessageCouponCode('');

    onClosed();
  }

  const requestCouponCode = (code) => {
    dispatch<any>(fetchCouponCode(branchId, code, sellingType, sellingModality, date)).then(response => {
      // Ensure response is a valid coupon object (should have id and attributes)
      if (response && response.id && response.attributes) {
        confirm(response);
      } else {
        console.error('Invalid coupon response:', response);
        setMessageCouponCode('Resposta inválida do servidor');
      }
    }).catch(error => {
      if (error.response && error.response.data && error.response.data.message) {
        setMessageCouponCode(error.response.data.message);
      } else {
        setMessageCouponCode('Erro ao validar cupom');
      }
    })
  }

  // const validate = (values, props) => {
  //   const errors: any = {};

  //   if (!values.code) {
  //     errors.code = 'Cupom deve ser preenchido';
  //   }

  //   return errors;
  // };

  const formik = useFormik<any>({
    initialValues: {
      code: '',
    },
    onSubmit: (values) => {
      console.log(values)
      requestCouponCode(values.code);
    },
    // validationSchema: validate
  })

  return (
    <>
      <Modal
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={true}
        show={isOpen}
        onHide={() => onClosed()}
        dialogClassName="custom-modal mw-600px"
        className="bg-black bg-opacity-50"
      >
          <Modal.Header>
            <Modal.Title id="cancel-schedule-title" className="flex-root d-flex justify-content-center">
              <h2 className="fd-uppercase">Cupons de desconto</h2>
            </Modal.Title>

            <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => onClosed()}>
              <span className="svg-icon svg-icon-1">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor" />
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor" />
                </svg>
              </span>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="mx-auto min-w-320px mw-500px w-100 pt-0 mb-5">
              <form
                    onSubmit={formik.handleSubmit}
                    noValidate
                    id='coupon_request_code'
                  >
              <div className="d-flex justify-content-center">
                <div className="d-flex w-100 mw-400px mb-1 flex-column flex-md-row">

                    <input
                      type="text"
                      placeholder="Digite o código do cupom"
                      {...formik.getFieldProps('code')}
                      className="form-control me-3"
                    />

                    <button
                      type="submit"
                      className="btn btn-primary fw-bold flex-shrink-0 w-100 w-md-50 w-md-150px mt-5 mt-md-0"
                    >
                      Aplicar cupom
                    </button>

                </div>
              </div>
              </form>
              {messageCouponCode != '' && <div className="d-flex justify-content-center">
                <div className="d-flex w-100 mw-400px mt-2 mb-1 flex-column flex-md-row">
                  <span className="d-flex text-danger w-100 mw-400px">
                    {messageCouponCode}
                  </span>
                </div>
              </div>}

              {/*{(messageCouponCode != '' || (formik.touched.code && formik.errors.code)) && <div className="d-flex justify-content-center">
                <div className="d-flex w-100 mw-400px mb-1 flex-column flex-md-row">
                  {messageCouponCode != '' && <span className="d-flex text-danger w-100 mw-400px">
                    {messageCouponCode}
                  </span>}
                  {formik.touched.code && formik.errors.code && <span className="d-flex text-danger w-100 mw-400px">
                    {formik?.errors?.code}
                  </span>}
                </div>
              </div>}*/}

              <div className="d-flex justify-content-center mt-4">
                <div
                  className={`btn btn-outline btn-outline-dashed btn-active-light-primary w-100 mw-400px d-flex flex-wrap text-start px-5 my-2 ${!selectedCoupon && `active `}`}
                  onClick={() => confirm({})}
                >
                  {/*<SVG src={toAbsoluteUrl('/media/svg/custom/coupons.svg')} width="40" height="40" className="me-5 align-self-center text-white" fill="white" />*/}
                  <div className="d-flex flex-column pe-7">
                      <div className="d-flex align-items-center fs-4 fw-bold mb-1">Sem cupom</div>
                      <div className="d-flex align-items-center fs-5 fw-semibold text-gray-600">Nenhum cupom aplicado</div>
                  </div>
                </div>
              </div>
              {/*<div className="d-flex justify-content-center">
                <div
                  className="btn btn-outline btn-outline-dashed btn-active-light-primary w-100 mw-400px d-flex flex-wrap text-start px-5 mt-2 flex-column"
                  onClick={() => confirm()}
                >
                  <div className="d-flex flex-row flex-wrap">
                    <SVG src={toAbsoluteUrl('/media/svg/custom/coupons.svg')} width="40" height="40" className="me-5 align-self-center text-white" fill="white" />
                    <div className="d-flex flex-column pe-7">
                      <div className="d-flex align-items-center fs-4 fw-bold mb-1 pt-2">10 OFF - Beach tenis</div>
                    </div>
                  </div>
                  <div className="d-flex flex-column flex-wrap">
                    <div className="d-flex align-items-center fs-6 fw-semibold text-gray-600">10% de desconto para beach</div>
                    <div className="d-flex align-items-center fs-6 fw-semibold text-gray-600">• Válido para Beach tennis</div>
                  </div>
                  <div className="d-flex flex-row pt-3">
                    <div className="flex-root align-items-center fs-8 text-primary">Ver regras</div>
                    <div className="text-end fs-8 text-gray-600">Válido até 17/06/2024 • 23:59</div>
                  </div>
                </div>
              </div>*/}
              {coupons.entities.length > 0 && coupons.entities.map(coupon => <>
                <div className="d-flex justify-content-center">
                  <div
                    className={`btn btn-outline btn-outline-dashed btn-active-light-primary w-100 mw-400px d-flex flex-wrap text-start px-5 mt-2 flex-column ${selectedCoupon == coupon.id && `active`}`}
                    onClick={(e) => {
                      if ((e.target as Element).className == 'flex-root align-items-center fs-8 text-primary') {
                        return false;
                      }

                      confirm(coupon)
                    }}
                  >
                    <div className="d-flex flex-row flex-wrap">
                      <SVG src={toAbsoluteUrl('/media/svg/custom/coupons.svg')} width="40" height="40" className="me-5 align-self-center text-white" fill="white" />
                      <div className="d-flex flex-column pe-7">
                        <div className="d-flex align-items-center fs-4 fw-bold mb-1 pt-2">{coupon.attributes.name}</div>
                      </div>
                    </div>
                    <div className="d-flex flex-column flex-wrap">
                      <div className="d-flex align-items-center fs-6 fw-semibold text-gray-600">{coupon.attributes.description}</div>
                      {coupon?.relationships?.coupon_restrictions?.length > 0 && <div className="d-flex align-items-center fs-6 fw-semibold text-gray-600">• Válido para {_.map(coupon.relationships.coupon_restrictions,'relationships.origin.attributes.name').join(",")}</div>}
                    </div>
                    {showRules == coupon.id && <div className="d-flex flex-column flex-wrap mt-5">
                      <div className="d-flex align-items-center fs-6 fw-semibold text-gray-600">• Somente para compras realizadas pelo app</div>
                      {coupon?.attributes?.weekdays?.length > 0 && <div className="d-flex align-items-center fs-6 fw-semibold text-gray-600">• Válido de {parseWeekDays(coupon.attributes.weekdays)}</div>}
                      {coupon?.attributes?.start_at && coupon?.attributes?.end_at && <div className="d-flex align-items-center fs-6 fw-semibold text-gray-600">• Entre os horários das {coupon.attributes.start_at} até {coupon.attributes.end_at}</div>}
                      <div className="d-flex align-items-center fs-6 fw-semibold text-gray-600">• Desconto de {coupon && coupon.attributes && parseValue(coupon.attributes.value, coupon.attributes.type)}</div>
                    </div>}
                    <div className="d-flex flex-row pt-3">
                      <div className="flex-root align-items-center fs-8 text-primary" onClick={() => setShowRules(showRules == coupon.id ? '' : coupon.id)}>{showRules == coupon.id ? `Ocultar regras` : `Ver regras`}</div>
                      <div className="text-end fs-8 text-gray-600">Válido até {formatLongDateTime(coupon.attributes.expired_at)}</div>
                    </div>
                  </div>
                </div>
              </>)}
            </div>
          </Modal.Body>
      </Modal>
    </>
  )
}

export {
  ListBranchCoupons
};

